
import { defineComponent } from "vue";

export default defineComponent({
  name: "TheLoadingMessage",
  setup() {
    console.log("TheLoadingMessage setup");
    const loadingMessageText = "送信中";

    return {
      loadingMessageText
    };
  }
});
